export function includesId(arr, id) {
  if (!arr || !id) return false;
  const idStr = id.toString();
  return arr.some(item => item?.toString() === idStr);
}

export function idsEqual(a, b) {
  if (!a || !b) return false;
  return a.toString() === b.toString();
}
